import { createApp } from 'vue'
import App from './App.vue'
import { makeServer } from './server'
import store from './store'

if (process.env.NODE_ENV === 'development') {
  makeServer()
}

const appElement = document.getElementById('app')
const appDataset = appElement?.dataset ?? {}

store.commit('updateActionUrl', appDataset.actionurl ?? null)
store.commit('updateConfigUrl', appDataset.configurl ?? null)
store.commit('updatePreflightUrl', appDataset.preflighturl ?? null)
store.commit('updateRecaptchaSiteKey', appDataset.recaptchaSiteKey ?? null)
store.commit('updateRecaptchaPreflightAction', appDataset.recaptchaPreflightAction ?? null)
store.commit('updateBID', Number.parseInt(appDataset.bid, 10) || 0)


createApp(App)
  .use(store)
  .mount('#app')
